import React from 'react';
import {
  AppBar,
  Box,
  Toolbar,
  useTheme,
  useMediaQuery,
  Divider,
  DividerProps,
  Typography,
} from '@mui/material';

import { Link } from 'react-router-dom';
import { getAuthState } from '../../../../store/AuthSlice';
import { useAppSelector } from '../../../../hooks';
import HeaderUserProfileOptionsViewer from '../../../V2/Portal/components/HeaderUserProfileOptionsViewer';
import NavigationOptionsIconButton from '../../../../components/Headers/NavigationOptionsIconButton';
import { getAppLogoUrl } from '../../../../helper';

const dividerProps: DividerProps = {
  flexItem: true,
  orientation: 'vertical',
  variant: 'middle',
  sx: { margin: '16px', borderWidth: '1px', backgroundColor: '#00000033' },
};

const Header: React.FC = () => {
  const theme = useTheme();
  const isXsScreen = useMediaQuery(theme.breakpoints.only('xs'));

  // Store
  const authState = useAppSelector(getAuthState);

  const authUser = authState.user;

  return (
    <Box data-testid="admin-app-header" sx={{ flexGrow: 1 }}>
      <AppBar position="fixed" color="inherit">
        <Toolbar>
          <NavigationOptionsIconButton />
          <Box
            component={Link}
            to={`${process.env.PUBLIC_URL}/`}
            style={{ margin: '3px 0 0 0', padding: 0 }}
          >
            <img
              src={getAppLogoUrl('tp-logo-text-green-new.png')}
              alt="tp-logo"
              style={{ width: '130px', height: '33px' }}
            />
          </Box>
          {!isXsScreen && (
            <>
              <Divider {...dividerProps} />
              <Typography
                sx={{ fontWeight: 500, fontSize: '20px', color: '#003768' }}
              >
                Learning Platform
              </Typography>
            </>
          )}
          <span style={{ flexGrow: 1 }} />
          {authUser && !authUser.role.isGuest ? (
            <HeaderUserProfileOptionsViewer />
          ) : null}
        </Toolbar>
      </AppBar>
    </Box>
  );
};

export default Header;
